import { CloudCustomerType } from "@omni/types/api/customer/cloud/shared/enums/customerType.enum";
import { ComponentsCustomerType } from "@omni/types/components/customer/shared/customerType.enum";

const fromCloudToComponents: Record<CloudCustomerType, ComponentsCustomerType> =
    {
        [CloudCustomerType.B2C]: ComponentsCustomerType.B2C,
        [CloudCustomerType.B2B]: ComponentsCustomerType.B2B
    };

const fromComponentsToCloud: Record<ComponentsCustomerType, CloudCustomerType> =
    {
        [ComponentsCustomerType.B2C]: CloudCustomerType.B2C,
        [ComponentsCustomerType.B2B]: CloudCustomerType.B2B
    };

export const ComponentsCustomerTypeMapper = {
    fromCloud: (deliveryType: CloudCustomerType): ComponentsCustomerType =>
        fromCloudToComponents[deliveryType]
};

export const CloudCustomerTypeMapper = {
    fromComponentsToCloud: (
        deliveryType: ComponentsCustomerType
    ): CloudCustomerType => fromComponentsToCloud[deliveryType]
};
